<template>
  <DragDialog
    :title="getTitle()"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="import-box">
      <div class="common-form-box">
        <el-form
          class="public-form-primary"
          :model="form"
          :rules="rules"
          :label-width="importType === 0 ? '136px' : '100px'"
          ref="form">
          <el-form-item
            label="选择项目所属人："
            prop="projOwner"
            class="common-select-box"
            v-if="importType === 0">
            <el-select
              popper-class="primary-select-outer"
              class="primary-select"
              size="small"
              filterable
              placeholder="请为该项目指定一个所属人"
              v-model="form.projOwner">
              <el-option
                v-for="(item, index) in projOwnerList"
                :key="index"
                :label="item.userName"
                :value="item.userId" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择项目："
            prop="projId"
            class="common-select-box"
            v-if="importType !== 0">
            <el-select
              popper-class="primary-select-outer"
              class="primary-select"
              size="small"
              filterable
              placeholder="请选择项目"
              v-model="form.projId"
              @change="handleProjChange">
              <el-option
                v-for="(item, index) in projList"
                :key="index"
                :label="item.projectName"
                :value="item.projectId" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="目录树节点："
            v-if="isFolderVisible()">
            <div class="common-select-box">
              <el-select
                popper-class="primary-select-outer select-not-hover"
                class="primary-select"
                ref="treeSelect"
                size="small"
                v-model="selectedNode.name">
                <el-option
                  style="height: 100%; padding: 0"
                  value="">
                  <div class="common-tree-box">
                    <el-tree
                      class="dialog-tree-primary select-tree-primary"
                      ref="tree"
                      :data="treeData"
                      :props="defaultProps"
                      node-key="id"
                      :expand-on-click-node="false"
                      @node-click="handleNodeClick">
                      <div
                        slot-scope="{ data }"
                        class="custom-node-box">
                        <div class="node-label-box">
                          <div
                            class="node-label text-overflow"
                            :title="data.name">
                            <span>{{ data.name }}</span>
                          </div>
                        </div>
                      </div>
                    </el-tree>
                  </div>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        class="tips-box publice-tips-primary"
        v-if="isFolderVisible()">
        注：仅新导入的数据集支持指定位置，更新时指定位置无效，默认导入原来的位置
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import {
  getExportOptionalProjListService,
  getProjOwnerListService,
  getImportFolderService
} from '@/service/interface'

export default {
  data() {
    return {
      form: {
        projOwner: undefined,
        projId: undefined
      },
      projOwnerList: [],
      projList: [],

      selectedNode: {},
      treeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'name'
      },
      rules: {
        projOwner: [
          {
            required: true,
            message: '请为该项目指定一个所属人',
            trigger: 'blur'
          }
        ],
        projId: [
          {
            required: true,
            message: '请选择项目',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    importType: Number,
    importFilesInfo: Array,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        if (this.importType === 0) {
          this.initOwnerList()
        } else {
          this.initProjList()
        }
      }
    }
  },
  methods: {
    initProjList() {
      getExportOptionalProjListService({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    initOwnerList() {
      getProjOwnerListService({}).then(response => {
        if (response.isSuccess) {
          let projOwnerList = response.data
          this.projOwnerList = projOwnerList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleProjChange() {
      if (!this.isFolderVisible()) return

      let importFilesInfo = this.importFilesInfo
      let schemeArray = []
      let formatTypeArray = []

      importFilesInfo.forEach(item => {
        let find = schemeArray.find(el => el === item.schemeType)
        if (!find) {
          schemeArray.push(item.schemeType)
        }

        let findIndex = formatTypeArray.findIndex(el => el === item.formatType)
        if (findIndex === -1) {
          formatTypeArray.push(item.formatType)
        }
      })

      if (schemeArray.length > 1 || formatTypeArray.length > 1) {
        this.$message.warning('只支持同一数据类型的导入')
        return
      }

      this.queryProjFolder(schemeArray[0], formatTypeArray[0]).then(
        response => {
          this.selectedNode = {}
          this.treeData = response
        }
      )
    },
    handleNodeClick(nodeData) {
      if (nodeData.id === this.selectedNode.id) return

      this.$refs.tree.setCurrentKey(nodeData.id)
      this.selectedNode = nodeData

      this.$refs.treeSelect.visible = false
    },
    submit() {
      this.$refs.form.validate(bool => {
        if (bool) {
          let importParams = {}
          if (this.importType === 0) {
            importParams = {
              ownerId: this.form.projOwner
            }
          } else {
            importParams = {
              projId: this.form.projId,
              targetNodeId: this.selectedNode.id
            }
          }

          this.$eventManage.fire('importFiles', { importParams })
          this.form = {
            projOwner: undefined,
            projId: undefined
          }
          this.closeDialog()
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    queryProjFolder(scheme, formatType) {
      return new Promise(resolve => {
        let params = {
          scheme,
          projId: this.form.projId,
          formatType
        }
        getImportFolderService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve([data])
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    cancel() {
      this.$eventManage.fire('cancelImport', null)
      this.form = {
        projOwner: undefined,
        projId: undefined
      }
      this.selectedNode = {}
      this.treeData = []
      this.closeDialog()
    },
    isFolderVisible() {
      if (this.importType !== 2) {
        return false
      }

      let importFilesInfo = this.importFilesInfo
      if (importFilesInfo.length) {
        let schemeArray = []
        importFilesInfo.forEach(item => {
          let find = schemeArray.find(el => el === item.schemeType)
          if (!find) {
            schemeArray.push(item.schemeType)
          }
        })

        if (schemeArray.length === 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getTitle() {
      let titleList = [
        { value: 0, name: '导入项目信息' },
        { value: 1, name: '导入场景' },
        { value: 2, name: '导入数据集' }
      ]
      let find = titleList.find(el => el.value === this.importType)
      return find.name
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.tips-box {
  font-size: 14px;
  color: var(--base-dark4-color);
  line-height: 20px;
}

.common-select-box {
  :deep(.el-select) {
    width: 100%;
  }
}
</style>

<style lang="less">
.select-tree-primary {
  min-height: 26px;
  .el-tree-node {
    &:first-child {
      margin-top: 0;
    }

    .el-tree-node__content{
      &:not(:last-child){
        margin-bottom: 4px;
      }
    }
  }
}

.select-not-hover{
  .el-select-dropdown__list{
    padding-bottom: 0;
  }
  .el-select-dropdown__item:hover{
    background-color: rgba(37, 128, 255, 0.055);
  }
  .el-select-dropdown__item.hover{
    background-color: transparent;
  }
}
</style>
